import script from "./inputLineNew2.vue?vue&type=script&setup=true&lang=ts"
export * from "./inputLineNew2.vue?vue&type=script&setup=true&lang=ts"

import "./inputLineNew2.vue?vue&type=style&index=0&id=3df62c96&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3df62c96"]])

export default __exports__